<div class="space-y-4">
  @if (isLoading()) {
    <div class="flex items-center justify-center py-12">
      <i class="pi pi-spin pi-spinner text-heading-2 text-primary-500"></i>
    </div>
  } @else {
    <app-reduction-actions />
    <app-custom-actions />
    <app-sdg-picker />
  }
</div>
